export default class Rank {
  static sort(stories) {
    const sorter = (a, b) => {
      const rankA = a.rank
      const rankB = b.rank

      if (rankA < rankB) {
        return -1
      }
      if (rankA > rankB) {
        return 1
      }

      return 0
    }

    return stories.sort(sorter)
  }
}
